import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchSurvey, onQuestionUpdate, onDetailUpdate, submit } from '../../../redux/survey'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'

import Survey from './component'

class SurveyContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      fetchedAt: null
    }
  }

  componentDidMount () {
    this.props.fetchSurvey()
    this.setState({
      fetchedAt: Date.now()
    })
  }

  componentDidUpdate (prevState) {
    if (this.props.resetAt > prevState.fetchedAt) {
      this.props.onDetailUpdate('name', '')
      this.props.onDetailUpdate('email', '')
      this.props.fetchSurvey()
      this.setState({
        fetchedAt: Date.now()
      })
    }
  }

  handleSubmit = (teamId, responses) => this.props.submit(teamId, responses)

  render () {
    if (this.props.isLoading) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }

    return (
      <Survey
        details={this.props.details}
        onDetailUpdate={this.props.onDetailUpdate}
        questions={this.props.questions}
        onQuestionUpdate={this.props.onQuestionUpdate}
        isSubmitting={this.props.isSubmitting}
        onSubmit={this.handleSubmit}
        submitted={this.props.submitted}
        submitError={this.props.submitError}
        teamId={this.props.teamId}
        deviceId={this.props.deviceId}
      />
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.survey.isLoading,
  isLoaded: state.survey.isLoaded,
  error: state.survey.error,
  details: state.survey.details,
  questions: state.survey.questions,
  resetAt: state.survey.resetAt,
  isSubmitting: state.survey.isSubmitting,
  submitError: state.survey.submitError,
  submitted: state.survey.submitted,
  teamId: state.team.id,
  deviceId: state.device.deviceId
})

export default connect(
  mapStateToProps,
  {
    fetchSurvey,
    onDetailUpdate,
    onQuestionUpdate,
    submit
  }
)(SurveyContainer)
